module.exports = __webpack_public_path__ + "static/media/14UNEP27.368cedd4.jpg";